import { render, staticRenderFns } from "./detailsExchange.vue?vue&type=template&id=30d6d1f4&scoped=true&"
import script from "./detailsExchange.vue?vue&type=script&lang=js&"
export * from "./detailsExchange.vue?vue&type=script&lang=js&"
import style0 from "./detailsExchange.vue?vue&type=style&index=0&id=30d6d1f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6d1f4",
  null
  
)

export default component.exports